<template>
  <v-container fluid name="nombreEnMetre">
        <table class="caisse">
          <tr v-for="n in milliers" :key="n">
            <td v-if="n%2" bgcolor=pink> 
                <img class="dm"
                  src=https://moncahier.com/maths/imagemm/100.gif>
            </td>
            <td v-else> 
                <img class="dm"
                  src=https://moncahier.com/maths/imagemm/100.gif>
            </td>
            <td v-if="n==1" :rowspan="milliers" valign=middle align=right>{{milliers}} mètre{{milliers>1?'s':''}}</td>
          </tr>
          <tr>
            <td v-if="centaines>0"> 
                <img class="dm"
                  :src="'https://moncahier.com/maths/imagemm/'+centaines+'0.gif'">
            </td>
            <td valign=middle align=right>{{centaines}} decimètre{{centaines>1?'s':''}}</td>
          </tr>
          <tr v-for="n in nombreDeVingtaines" :key="n">
            <td valign=top :align="isEvenCent?'left':'right'" bgcolor=pink>
                <img class="cm"  :src='"https://moncahier.com/maths/imagemm/2"+(isEvenCent?"g":"d")+".gif"'>
            </td>
            <td v-if="n==1" :rowspan="nombreDeVingtaines+!isEvenDecade" valign=middle align=right>{{dizaines}} centimètre{{dizaines?'s':''}}</td>
          </tr>
          <tr v-if="(!isEvenDecade)">
            <td valign=top :align="isEvenCent==0?'right':'left'" bgcolor=pink>
                <img  :src='"https://moncahier.com/maths/imagemm/1"+(isEvenCentandDecade?"d":"g")+".gif"'>
            </td>
          </tr>
          <tr>
            <td valign=top :align="isEvenCentandDecade?'left':'right'" bgcolor=white>
                <img class="cm"  :src='"https://moncahier.com/maths/imagemm/0"+unites+(isEvenCentandDecade?"g":"d")+".gif"'>
            </td>
            <td :rowspan="unites" valign=middle align=right>{{unites}} millimètre{{unites?'s':''}}</td>
          </tr>
        </table>
  </v-container>
</template>
<script>

  export default {
    name: "NombreEnMetre",
    components: {
    },
    watch: {
      parsedNumber:function(p){
        this.milliers=parseInt(p[0]);
        this.centaines=parseInt(p[1]);
        this.isEvenCent=!(this.centaines%2);
        this.dizaines=parseInt(p[2]);
        this.isEvenCentandDecade=!((this.centaines+this.dizaines)%2);
        this.isEvenDecade=!(this.dizaines%2);
        this.nombreDeVingtaines= parseInt(this.dizaines/2);
        this.unites=parseInt(p[3]);

      }
    },
    props: {
      parsedNumber:Array,
    },
    data () {
      return {
        milliers:0,
        centaines:0,
        isEvenCent:true,
        dizaines:0,
        isEvenCentandDecade:true,
        isEvenDecade:true,
        nombreDeVingtaines:0,
        unites:0,
      }
    },
    methods: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  img.dm{
    width: 100mm;
  }
  img.cm{
    width: 10mm;
  }
  table{
    line-height: 0%;
    border-collapse: collapse;
  }
  .ned{
    height: 30px;
  }
  .caisse{
    width:0px;
  }
</style>
